<template>
  <BaseButtonIcon
    outline
    :title="$t('product_events.EXPORT_USERS')"
    :aria-label="$t('product_events.EXPORT_USERS')"
    size="small"
    @click="exportAttendees"
  >
    <ExportIcon />
  </BaseButtonIcon>
</template>

<script setup lang="ts">
import { useOnError } from '@/hooks/swr/helpers/useOnError'
import { downloadAttendees } from '@/service/v3/endpoints/events'
import { ref } from 'vue'
import BaseButtonIcon from '@/components/generics/base/BaseButtonIcon.vue'
import ExportIcon from '@/components/icon_components/ExportIcon.vue'
import { RegistrationStatus } from '@/gql/graphql'

// The "All" filter has no explicit status set, so we send every status to make
// the export mirror that tab regardless of the backend's default behaviour.
const ALL_REGISTRATION_STATUSES = [
  RegistrationStatus.Registered,
  RegistrationStatus.Attended,
  RegistrationStatus.Pending,
  RegistrationStatus.NoShow,
]

const props = defineProps<{
  courseId: number
  statuses?: RegistrationStatus[]
}>()
const error = ref<any>(undefined)

useOnError(error)

const exportAttendees = async () => {
  try {
    await downloadAttendees(
      props.courseId,
      'xlsx',
      props.statuses ?? ALL_REGISTRATION_STATUSES
    )
  } catch (caughtError) {
    error.value = caughtError
  }
}
</script>
